import styled from 'styled-components'

export const SearchRoot = styled.section`
  box-sizing: border-box; width: 100%; max-width: 1280px; margin: 0 auto 32px; padding: 32px 40px 40px;
  color: ${p => p.theme.palette.colors.text};
  @media (max-width: 600px) { padding: 24px 16px; }
`
export const SearchTitle = styled.h1`
  font-size: clamp(24px, 3vw, 32px); font-weight: 600; letter-spacing: -0.7px;
  line-height: 1.3; margin: 0 0 28px; overflow-wrap: anywhere;
`
export const Tabs = styled.nav`
  display: flex; gap: 28px; overflow-x: auto; border-bottom: 1px solid ${p => p.theme.palette.colors.borderStrong};
  margin-bottom: 20px; padding: 2px 2px 0;
  @media (max-width: 600px) { gap: 20px; }
`
export const Tab = styled.button`
  display: inline-flex; align-items: center; gap: 8px;
  color: ${p => p.$active ? p.theme.palette.colors.text : p.theme.palette.colors.muted};
  border: 0; border-bottom: 3px solid ${p => p.$active ? p.theme.palette.blue.main : 'transparent'};
  background: transparent; padding: 12px 0 16px; white-space: nowrap; font: inherit; font-size: 14px;
  font-weight: ${p => p.$active ? 600 : 400}; cursor: pointer;
  &:hover { color: ${p => p.theme.palette.colors.text}; }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: -2px; }
`
export const TabCount = styled.span`
  border-radius: 6px; padding: 2px 6px; font-size: 12px; font-variant-numeric: tabular-nums;
  background: ${p => p.theme.palette.colors.surface}; color: ${p => p.theme.palette.colors.muted};
`
export const Summary = styled.p`font-size: 14px; color: ${p => p.theme.palette.colors.muted}; margin: 0; line-height: 1.6;`
export const Notice = styled.p`
  display: flex; align-items: flex-start; gap: 8px; font-size: 13px; line-height: 1.6;
  color: ${p => p.theme.palette.colors.muted}; margin: 0 0 16px;
  svg { width: 18px; height: 18px; flex-shrink: 0; margin-top: 1px; }
`
export const Toolbar = styled.div`
  display: flex; justify-content: space-between; align-items: center; gap: 16px; margin: 24px 0;
  @media (max-width: 600px) { gap: 12px; flex-wrap: wrap; }
`
export const Results = styled.div`
  display: grid; gap: 20px;
  grid-template-columns: ${p => p.$documents || p.$images ? 'repeat(4, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))'};
  @media (max-width: 1100px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 700px) { gap: 20px; grid-template-columns: minmax(0, 1fr); }
`
export const RelatedTitle = styled.h2`font-size: 18px; margin: 28px 0 0; grid-column: 1 / -1;`
export const Paging = styled.div`display: flex; justify-content: center; margin-top: 32px; overflow-x: auto;`
export const SecondaryAction = styled.button`
  margin-top: 24px; padding: 12px 18px; border: 1px solid ${p => p.theme.palette.colors.borderStrong};
  border-radius: 8px; background: ${p => p.theme.palette.colors.surface}; color: ${p => p.theme.palette.colors.text};
  font: inherit; font-size: 14px; cursor: pointer;
  &:hover { background: ${p => p.theme.palette.colors.controlSurface}; }
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 3px; }
`
